import { FormSec002Filter } from './../../entity/models/form-sec002-filter';
import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { take } from 'rxjs/operators';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { FilterDetailComponent } from 'src/app/shared/filter-detail/filter-detail.component';
import { FormSec002FilterComponent } from './form-sec002-filter.component';
import { SimpleModalComponent } from 'src/app/shared/simple-modal/simple-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-list-form-sec002',
  templateUrl: './list-form-sec002.component.html',
  styleUrls: ['./list-form-sec002.component.scss']
})

export class ListFormSec002Component implements OnInit, AfterViewInit {

  public displayedColumns?: string[] = ['CreatedAt', 'CreatedBy', 'Safra', 'SiteRecebimento', 'ControleSecagem', 'SecadorCamara', 'Hibrido', 'Lote DS',
    'Local Atual', 'Status', '#'];
  public displayedColumnsBasic?: string[] = ['CreatedAt', 'CreatedBy', 'Safra', 'SiteRecebimento', 'ControleSecagem', 'SecadorCamara', 'Hibrido', 'Lote DS',
    'Local Atual', 'N° do Campo', 'Status', '#'];
  public displayedColumnsPreBasic?: string[] = ['CreatedAt', 'CreatedBy', 'SafraBasica', 'SiteRecebimento', 'ControleCaixa', 'Hibrido', 'N° do Campo', 'Status', '#'];
  public dataSource?: MatTableDataSource<any>;
  public header?: CabecalhoDTO;
  public dataFilters?: Array<any> = new Array<any>();
  public pageSizeOptions?: number[] = [];
  public areaSelect: string = localStorage.getItem('area-select') || null;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(FilterDetailComponent, { static: false }) filterDetailComponent: FilterDetailComponent;
  @ViewChild(FormSec002FilterComponent, { static: false }) formSec002FilterComponent: FormSec002FilterComponent;

  permissionDelete: boolean = false;

  // tslint:disable-next-line: max-line-length
  constructor(protected generalService: GeneralService, protected formularioService: FormularioService,
    protected notificationService: NotificationService, private dialog: MatDialog) {
    this.header = new CabecalhoDTO();
    this.pageSizeOptions = this.formularioService.pageSizeOptions;
  }

  showFilter(): void {
    this.filterDetailComponent.showMenu(true);
  }

  async ngAfterViewInit(): Promise<void> {
    await this.getData();
    await this.getUserPermissionDelete();
  }

  async ngOnInit(): Promise<void> {
    this.header = this.generalService.createHeader(EnumForm.FormSec002, EnumFormType.List);
  }

  getColumnsList(): string[] {
    // tslint:disable-next-line: max-line-length
    var columnsList = []
    if (this.areaSelect.includes('Pré-Básica')) {
      columnsList = ['id', 'safra_basica', 'site_recebimento', 'controle_caixa', 'secador_camara', 'is_incomplete', 'created_at', 'created_by',
        'hibrido_rnc_linhagem', 'lote_ds', 'local_atual', 'n_de_campo_basica']
    }
    else if (this.areaSelect.includes('Básica')) {
      columnsList = ['id', 'safra', 'site_recebimento', 'controle_secagem', 'secador_camara', 'is_incomplete', 'created_at', 'created_by',
        'hibrido_rnc_linhagem', 'lote_ds', 'local_atual', 'n_de_campo_basica']
    }
    else {
      columnsList = ['id', 'safra', 'site_recebimento', 'controle_secagem', 'secador_camara', 'is_incomplete', 'created_at', 'created_by',
        'hibrido_rnc_linhagem', 'lote_ds', 'local_atual']
    }

    return columnsList
  }

  configDataTable(lista: Array<any>): void {
    this.dataSource = new MatTableDataSource(lista);
    this.dataSource.paginator = this.paginator;
    this.dataSource.paginator._intl.firstPageLabel = this.formularioService.firstPageLabel;
    this.dataSource.paginator._intl.lastPageLabel = this.formularioService.lastPageLabel;
    this.dataSource.paginator._intl.itemsPerPageLabel = this.formularioService.itemsPerPageLabel;
    this.dataSource.paginator._intl.nextPageLabel = this.formularioService.nextPageLabel;
    this.dataSource.paginator._intl.previousPageLabel = this.formularioService.previousPageLabel;
    // tslint:disable-next-line: max-line-length
    this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) { return `0 de ${length}`; }
      length = Math.max(length, 0); const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length)
        // tslint:disable-next-line: align
        : startIndex + pageSize; return `${startIndex + 1} – ${endIndex} de ${length}`;
    };
    this.dataSource.sort = this.sort;
  }

  async getFilter(filter): Promise<void> {

    // tslint:disable-next-line: max-line-length
    await this.formularioService.getAllFilter('vw_sec002', { filters: filter, columns: this.getColumnsList() }).pipe(take(1)).toPromise().then((response: any) => {

      this.dataFilters = filter;
      this.configDataTable(response?.data);

    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, error.message);
    });
  }

  async getData(): Promise<void> {

    const status = await this.generalService.getConnectionStatus();
    const data_offline = await this.generalService.getDataFromLocalStorage('vw_sec002');
    if (status) {
      if (data_offline?.length > 0) {
        await this.setData('vw_sec002', this.getColumnsList(), 'vw_sec002', true, data_offline);
      } else {
        await this.setData('vw_sec002', this.getColumnsList(), 'vw_sec002', false, data_offline);
      }
    } else {
      await this.configDataTable(data_offline);
    }
  }

  private async setData(sheet?: string, columnsList?: string[], fileName?: string, blMakeConcat?: boolean, data_offline?: []): Promise<any> {
    let result = [];
    // tslint:disable-next-line: max-line-length
    await this.formularioService.getAllFilter(sheet, { filters: this.getStartFilter(), columns: columnsList }).pipe(take(1)).toPromise().then((response: any) => {
      if (blMakeConcat) {
        result = data_offline.concat(response?.data);
      } else {
        result = response?.data;
      }
      this.configDataTable(result);
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, error.message);
      this.configDataTable(await this.generalService.getDataFromLocalStorage(fileName));
    });
  }

  public async makeSync(): Promise<void> {
    let data_offline: Array<any> = await this.generalService.getDataFromLocalStorage('sec002');
    if (!!data_offline && data_offline.length > 0) {

      for (let i = 0; i < data_offline.length; i++) {
        delete data_offline[i].offline;
      }

      await this.formularioService.makeSync('sec002', data_offline).pipe(take(1)).toPromise().then(async (response: any) => {
        localStorage.removeItem('data_sec002');
        this.notificationService.sendNotification('', TypeMessage.Sync, ActionMessage.Success);
        await this.getData();
      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, error.message, TypeMessage.SyncError);
      });
    } else {
      this.notificationService.sendNotification('', TypeMessage.SyncListEmpty, ActionMessage.Info);
    }
  }

  private getStartFilter(): FormSec002Filter {
    const site: string = this.generalService.getLocalStorageDataSite();
    this.formSec002FilterComponent.formulario.get('site_recebimento').setValue(site);
    const filter: FormSec002Filter = new FormSec002Filter()
    filter.site_recebimento = site;
    return filter;
  }

  formatNumberPesoDebulha = (value: string) => {
    let parse = Number(value)
    let result = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'USD' }).format(parse);
    let replace = result.toString().replace('$', '');

    return replace;
  }

  getUserPermissionDelete = async () => {
    await this.formularioService.userIsAdmin().subscribe(adm => {
      if (adm) this.permissionDelete = true;
      else {
        this.formularioService.userIsManager().subscribe(manager => {
          if (manager) this.permissionDelete = true;
          else this.permissionDelete = false;
        })
      }
    })
  }

  delete = (id) => {
    let input = {
      title: 'Excluír registro',
      titleBtn1: 'Não',
      titleBtn2: 'Sim',
      mensage: 'Deseja realmente excluír esse registro?',
    };

    const dialogRef = this.dialog.open(SimpleModalComponent, {
      width: '600px',
      data: input,
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.deleteConfirm(id);
      }
    });
  }

  deleteConfirm = (id) => {
    this.formularioService.deleteForm('sec002', id).subscribe(async res => {
      this.notificationService.sendNotification('Registro excluído com sucesso', TypeMessage.Delete, ActionMessage.Success);
      await this.getData();
    }, err => {
      this.notificationService.showNotificationError(err, 'Ocorreu um problema ao excluído o registro', TypeMessage.Delete);
    })
  }
}
